var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nz-cascader',{attrs:{"options":_vm.options,"props":_vm.props,"clearable":_vm.clearable},on:{"active-item-change":_vm.onActiveItemChange},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c973775","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/framework/components/base/region-select/src/region-select.vue
// module id = null
// module chunks = 